import p1Png from "../images/onb.png";
import p1Webp from "../images/onb.webp";
import p2Png from "../images/tr.png";
import p2Webp from "../images/tr.webp";
import p3Png from "../images/mot.png";
import p3Webp from "../images/mot.webp";
import p4Png from "../images/ui.png";
import p4Webp from "../images/ui.webp";

export const data = [
  {
    image: {
      png: p1Png,
      webp: p1Webp,
    },
    title: `Onboarding`,
    text: [
      `At this stage, we get to know the user and his needs. You take a short survey to understand your: purposes, parameters, age, training frequency`,
    ],
  },
  {
    image: {
      png: p2Png,
      webp: p2Webp,
    },
    title: `Training`,
    text: [
      `Once the app has all the answers to your questions, you're ready to work out.`,
      `
      There is no need to go somewhere or adjust your schedule.`,
    ],
  },
  {
    image: {
      png: p3Png,
      webp: p3Webp,
    },
    title: `Motivation`,
    text: [
      `The app makes it easy to track your achievements. And thanks to gamification, you will always come back to Shapely! Pump your character, as it is in the game, and get winning points!`,
    ],
  },
  {
    image: {
      png: p4Png,
      webp: p4Webp,
    },
    title: `UI/UX`,
    text: [
      `With Shapely you feel light and simple, it does not overload you with unnecessary information. And jokes in a frivolous tone will make you smile. All in order to reduce the distance between you and sports`,
    ],
  },
];
